import type React from "react"
import styled from "styled-components"
import backgroundImage from "~/assets/arbeidsark-bg-illustration.svg"
import { OutlineButton } from "~/components"
import Toast from "~/modules/toasts/Toast"
import { useTranslate } from "~/ur-react-hooks"
import { useLogout } from "~/utils/hooks/useLogout"

const Layout = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  background-image: url(${backgroundImage});

  ${(props) =>
    props.theme.media.mobile &&
    `
      width: 100%;
  `}
`

const Title = styled.h3`
  font-family: 'Work Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 145%;
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: 456px;
  box-sizing: border-box;

  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 8px 32px 0 rgba(27, 12, 55, 0.12);
`

const Description = styled.p`
  line-height: 150%;
  text-align: center;
`

const Actions = styled.div`
  margin-top: 1rem;
`

export type ExistingSchoolWaitingAcceptanceProps = {}

const ExistingSchoolWaitingAcceptance: React.FC<
  ExistingSchoolWaitingAcceptanceProps
> = () => {
  const logout = useLogout()
  const translations = useTranslate({
    title: "existing-school-waiting-acceptance.title",
    description: "existing-school-waiting-acceptance.description",
    toast: "existing-school-waiting-acceptance.toast",
    logout: "common.log-out",
  })

  return (
    <Layout>
      <Card>
        <Title>{translations.title}</Title>
        <Toast type="success" message={translations.toast} />
        <Description>{translations.description}</Description>
        <Actions>
          <OutlineButton
            width="100%"
            onClick={() => {
              logout()
            }}
          >
            {translations.logout}
          </OutlineButton>
        </Actions>
      </Card>
    </Layout>
  )
}

export default ExistingSchoolWaitingAcceptance
